<template>
  <div>
    <cx-dialog v-if='showUploadForm'
               :visible="showUploadForm"
               :title="'上传电子文件'"
               width="50%"
               :showOkBtn="false"
               @close='showUploadForm = false; query()'>
      <el-row>
        <el-col :span="24">
          <cx-upload-files :fileList="fileList"
                           :action="CX_API_ROOT + '/bill/upload'"
                           :delUrl="CX_API_ROOT + '/bill/delete-file'"
                           :data="uploadData"></cx-upload-files>
        </el-col>
      </el-row>
    </cx-dialog>

    <cx-btn-group>
      <el-button type="success" icon="el-icon-check" size='mini'
                 @click='save'>提交服务单</el-button>
      <el-button type="primary" icon="el-icon-upload2" size='mini'
                 @click='upload'>上传</el-button>
    </cx-btn-group>

    <div>
      <el-form :model="form" :rules="rules" ref="form" :loading="loading">
        <div style="margin-left:28px">
          <el-row>
            <el-col :span="24">
              <h3>业务内容</h3>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:28px">
            <el-col :span="24">
              <span style="color:green">提示：如有附件，请在提交服务单前上传!</span>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:28px">
            <el-col :span="24">
              <el-form-item label="业务内容 （请在此详细说明业务需求，若有图片，请  点此 上传,支持 .jpg, .png, .gif格式。）" prop="comment">
                <cx-input v-model='form.comment' :type="'textarea'"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="margin-left:28px">
          <el-row style="margin-bottom:28px">
            <el-col :span="24">
              <span>员工信息（若该业务涉及到具体员工，请在此选择，若没有，请为空）</span>
            </el-col>
          </el-row>
          <el-transfer v-model="form.emp_list" :data="empList" :titles="['员工列表', '已选择员工']" filterable></el-transfer>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        data: [],
        bill_id: null,
        
        empList: [],
        billStatusList: [],
        serTypeList: [],

        servData: [],
        empData: [],
        showForm: false,
        showUploadForm: false,

        title: '',
        form: {
          comment: '',
          emp_list:[],
        },
        uploadData: {
          id: null,
        },
        rules:{
          comment: [{required: true, trigger: 'blur', message: '请输入备注'}]
        }
      }
    },
    mounted() {
      this.queryDictionaries(this.addBill);
      this.query();
    },
    methods: {
      query() {
        this.loading = true;
        let postData = {};
        this.post('/client-employee/list', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              this.empList = resp.data['rows'] || [];
              for(let i=0;i<this.empList.length;i++) {
                this.empList[i].key = this.empList[i].id;
                this.empList[i].label = this.empList[i].name;
              }
            }
          }
        })
      },
      queryDictionaries(callback) {
        this.post('/sys-dictionaries/list', {
            types: '52, 53',
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.MAX_ROWS,
        }).then(resp => {
          if (resp) {
            if (resp.data.success) {
              let rows = resp.data['rows'] || [];
              rows.forEach(row => {
                switch (row.type) {
                  case 52:
                    this.billStatusList.push(row);
                    break;
                  case 53:
                    this.serTypeList.push(row);
                    break;
                }
              });
              if(callback){
                callback();
              }
            }
          }
        });
      },
      addBill() {
        this.loading = true;
        let postData = {};
        postData.type = this.serTypeList[9].id
        postData.feedbacker = 20001;
        this.post('/bill/add', postData).then(resp => {
          this.loading = false;
          if(resp) {
            if(resp.data['success']) {
              this.bill_id = resp.data['obj'].id || null;
            }
          }
        })
      },
      save() {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.loading = true;
            let postData1 = {};
            postData1.id = this.bill_id;
            let emp_list1 = [];
            postData1.status = this.billStatusList[1].id;
            for(let i=0;i<this.form.emp_list.length;i++){
              this.empList.filter(item => item.key == this.form.emp_list[i].key)
              emp_list1.push(this.empList.filter(item => item.key == this.form.emp_list[i])[0].name);
            }
            postData1.feedback = "客户申请办理的业务内容："+ this.form.comment + "；该业务涉及到的具体员工信息："+emp_list1.join(",");;
            this.post('/bill/modify', postData1).then(resp => {
              this.loading = false;
              if(resp) {
                if(resp.data['success']) {
                  this.success('服务单提交成功，请等待客服处理！');
                  this.form.comment = '';
                  this.form.emp_list = [];
                  this.query();
                  this.addBill();
                }else{
                  this.error('服务单提交失败，请联系客服人员！');
                  this.form.comment = '';
                  this.form.emp_list = [];
                  this.query();
                  this.addBill();
                }
              }
            })
          }
        });
      },
      upload() {
        this.fileList = [];
        let row = {};
        this.uploadData.id = this.bill_id;
        if(row.file_ids) {
          this.post('/file/emp-list', {
            ids: row.file_ids
          }).then(resp => {
            if(resp) {
              if (resp.data.success) {
                this.fileList = resp.data['rows'] || [];
                this.showUploadForm = true;
              }
            }
          });
        } else {
          this.showUploadForm = true;
        }
      },
    },
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/insurance/other/list.vue